import Accessor from '@arcgis/core/core/Accessor';
import { property, subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { whenDefinedOnce, whenTrueOnce } from '@arcgis/core/core/watchUtils';
import WebMap from '@arcgis/core/WebMap';
import WebScene from '@arcgis/core/WebScene';
import PortalGroup from '@arcgis/core/portal/PortalGroup';

@subclass('Landing.data.ItemLoader.ItemLoaderViewModel')
export default class ItemLoaderViewModel extends Accessor {

    @property()
    portal: __esri.Portal;

    /** Has the item been instantiated? */
    @property()
    isItemLoaderDone: boolean = false;

    /** Has the instantiated item loaded fully? */
    @property()
    isItemLoaded: boolean = false;

    /** Has the resource loading errored out? */
    @property()
    isItemLoadedError: boolean = false;

    @property()
    webmap: WebMap;

    @property()
    webscene: WebScene;

    @property()
    group: PortalGroup;

    @property()
    loadedItemType: "webmap" | "webscene" | "group" | "none";

    constructor(params?: any) {
        super(params);

        whenDefinedOnce(this, "portal", () => {
            const { portal } = this;
            const urlParams = new URLSearchParams(window.location.search);
            const webmapId: string = urlParams.get('webmap');
            const websceneId: string = urlParams.get("webscene");
            const groupId: string = urlParams.get("group");
            if (webmapId) {
                this.webmap = new WebMap({
                    portalItem: {
                        id: webmapId,
                        portal
                    }
                });
                this.loadedItemType = "webmap";
            } else if (websceneId) {
                this.webscene = new WebScene({
                    portalItem: {
                        id: websceneId,
                        portal
                    }
                });
                this.loadedItemType = "webscene";
            } else if (groupId) {
                this.group = new PortalGroup({
                    id: groupId,
                    portal
                });
                this.loadedItemType = "group";
            } else {
                this.loadedItemType = "none";
            }
            this.isItemLoaderDone = true;

            this._determineIfItemLoaded();
        });
    }

    private async _determineIfItemLoaded(): Promise<void> {
        if (this.loadedItemType === "group" || this.loadedItemType === "none") {
            this.isItemLoaded = true;
        } else if (this.loadedItemType === "webmap") {
            this.webmap.loadAll().then(() => {
                whenTrueOnce(this.webmap, "loaded", () => {
                    this.isItemLoaded = true;
                });
            }).catch((err) => {
                console.error(err);
                this.isItemLoadedError = true;
            })
        } else if (this.loadedItemType === "webscene") {
            this.webscene.loadAll().then(() => {
                whenTrueOnce(this.webscene, "loaded", () => {
                    this.isItemLoaded = true;
                });
            }).catch((err) => {
                console.error(err);
                this.isItemLoadedError = true;
            })
        }
    }
}
